import React from 'react';
import './App.css';
import { words } from "./words.js";
import RICIBs from 'react-individual-character-input-boxes';

var foundCount = 0;

type AppState = {
    count: number,
    regex: string,
    matches: string[]
}

export default class App extends React.Component<any,AppState> {

    state: AppState = {
        count: 0,
        regex: "?????",
        matches: []
    };

    handleOutput(out: string) {
        var regex: string = out.replaceAll('?', '.')
        var matches = words.filter(word => word.match(regex))
        var count = matches.length

        this.setState(state => ({count: count, regex: regex, matches: matches}));
    }

    intersperse(arr: string[], sep: string) {
        if (arr.length === 0) {
            return [];
        }

        return arr.slice(1).reduce(function(xs, x, i) {
            return xs.concat([sep, x]);
        }, [arr[0]]);
    }

    render() {
        var plural = this.state.count > 1 ? "s" : ""
        var commaWords = this.intersperse(this.state.matches, " ")

        var matchedWords = this.state.count == 0 ? "" :
            commaWords.slice(0,20)

        return (
            <div className="App">
              <header className="App-header">
                <h3> Wordle "Helper" </h3>
                <p><i>Use ? for unknown letters</i></p>
                <div>
                  <RICIBs
                      amount={5}
                      autoFocus
                      handleOutputString={this.handleOutput.bind(this)}
                      inputProps={[
                        { className: "first-box" },
                        { style: { "color": "black" } },
                        { placeholder: "" }
                      ]}
                      inputRegExp={/^[a-z?]$/}
                    />
                </div>
                <p>
                {matchedWords}
                </p>
                <p>
                {this.state.count} matching word{plural}
                </p>
              </header>
            </div>
          );
    }
}

// export default App;
